import NafNoneAdapter from "./adapter/none/NafNoneAdapter";

/**
 * Adapter loading will be async so this clas will be used to wrap the adapter waiting for it to load
 * implements AdapterI interface
 */
export class AdapterWrapper extends NafNoneAdapter{

}
